/**
 * 账本页的文案。命名空间 `visualGameAdmin.llm.ledger.*`。
 *
 * `en` 与 `zh` 的 key 集必须逐字相同 —— `test/i18n.test.js` 拍平后逐项比对六个语种
 * （`ja`/`es`/`id`/`pt` 是 `structuredClone(en)` 的桩，自动跟随）。
 */

export const en = {
  gotoCalls: 'All calls',
  empty: 'No entries',
  table: {
    time: 'Time',
    type: 'Type',
    reason: 'Reason',
    amount: 'Change',
    balanceAfter: 'Balance',
    call: 'Call',
  },
}

export const zh = {
  gotoCalls: '全部调用',
  empty: '没有流水',
  table: {
    time: '时间',
    type: '类型',
    reason: '事由',
    amount: '变动',
    balanceAfter: '余额',
    call: '关联调用',
  },
}
